import { useEffect } from "react";

import { SelectV2 } from "@/modules/common/components";
import { useFilters } from "@/modules/common/filters";
import { FILTER_KEYS } from "@/modules/common/filters/keys";
import { usePagination } from "@/modules/common/hooks/usePagination";
import { ANEEL_TARIFF_IMPORT_STATUS_OPTIONS, AneelTariffImportHistoryStatus } from "@/modules/common/types/AneelTariffs.enum";
import { ListAneelTariffImportHistoryDto } from "@/service/dto/admin-aneel-tariffs";

import { ANEEL_TARIFF_IMPORT_HISTORY_FILTER_FIELDS } from "../../constants/ImportHistoryFilterFields";
import useAneelTariffImportHistory from "../../hooks/useAneelTariffImportHistory";
import ImportHistoryList from "./ImportHistoryList";

const ImportHistoryTab = () => {
  const filters = useFilters<ListAneelTariffImportHistoryDto>({
    fields: ANEEL_TARIFF_IMPORT_HISTORY_FILTER_FIELDS,
    filterKey: FILTER_KEYS.ANEEL_TARIFF_IMPORT_HISTORY,
  });

  const { page, setPage, limit, setPageSize } = usePagination();

  const filtersKey = JSON.stringify(filters.queryParams);
  useEffect(() => {
    setPage(1);
  }, [filtersKey]);

  const {
    data: importHistory,
    isLoading: isImportHistoryLoading,
    isFetching: isImportHistoryFetching,
  } = useAneelTariffImportHistory({ ...filters.queryParams, page, limit });

  return (
    <div className="flex flex-col gap-4">
      <div className="w-full flex bg-white rounded-lg p-4">
        <div className="w-full sm:w-72">
          <SelectV2
            mode="single"
            placeholder="Status"
            options={ANEEL_TARIFF_IMPORT_STATUS_OPTIONS}
            value={filters.values.status !== undefined ? String(filters.values.status) : undefined}
            onChange={(next) =>
              filters.setValue("status", next !== undefined ? (Number(next) as AneelTariffImportHistoryStatus) : undefined)
            }
          />
        </div>
      </div>

      <ImportHistoryList
        data={importHistory}
        isLoading={isImportHistoryLoading}
        isFetching={isImportHistoryFetching}
        limit={limit}
        onChangePage={setPage}
        onChangePageSize={setPageSize}
      />
    </div>
  );
};

export default ImportHistoryTab;
